import AuthSocialForm from "./AuthSocialForm";

export default AuthSocialForm;
